module.exports = __webpack_public_path__ + "img/img_25.e24f277c.png";